import { render } from "./HeroiconsSolidScale.vue?vue&type=template&id=6cbd3ec2"
const script = {}

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidScale.vue"]])

export default __exports__